<!-- 播放量趋势弹窗(单线) -->
<template>
  <div>
    <el-dialog
      width="960px"
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      showClose
      append-to-body
      center
      v-if="dialogFormVisible"
    >
      <div class="eachars-box programTotal">
      <div class="daterange">
        <el-date-picker
          @change="formChange"
          v-model="categoryTime"
          type="daterange"
          value-format="timestamp"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </div>
      <div id="weekAna" :style="{width: '100%', height: '300px'}"></div>
    </div>
    </el-dialog>
  </div>

</template>
<script>
import { trendChartData } from '@/resource/api/ugcIndex.js'
// import logoOpenUrl from '@/assets/logo_open.png'
export default {
  props: ['dialogData'],
  data () {
    return {
      dialogTitle: '',
      dialogFormVisible: false,
      categoryTime: [],
      defaultDate: [
        new Date(new Date(new Date().toLocaleDateString()).getTime() - 6 * 24 * 60 * 60 * 1000).getTime(),
        new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1).getTime()
      ],
      pickerOptions: {
        disabledDate: (time) => {
          // 不可选中180天前日期
          return this.dealDisabledDate(time)
        }
      },
      form: {
        stageName: this.$store.state.router.anchorId,
        statisticsFields: '',
        programId: '',
        startTime: '',
        endTime: '',
        isCharge: '',
        limit: ''
      },
      itemBox: null
    }
  },
  mounted () {

  },
  methods: {
    open () {
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.pageInit() // 初始化数据
      })
    },
    pageInit () {
      if (this.dialogData.categoryTime) {
        this.categoryTime = this.dialogData.categoryTime
        this.form.startTime = this.dialogData.categoryTime[0]
        this.form.endTime = this.dialogData.categoryTime[1]
      } else {
        this.form.startTime = this.defaultDate[0]
        this.form.endTime = this.defaultDate[1]
        this.categoryTime = [this.form.startTime, this.form.endTime]
      }

      this.weeksData() // 周数据分析
    },
    formChange (timeArr) {
      if (timeArr === null) {
        this.form.startTime = ''
        this.form.endTime = ''
      } else {
        this.form.startTime = timeArr[0]
        this.form.endTime = timeArr[1]
        this.getItem()
      }
    },
    dealDisabledDate (time) {
      const today = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1
      if (new Date(time).getTime() > today) {
        return time.getTime() >= today // 时间范围必须是时间戳
      } else {
        return time.getTime() < Date.now() - 180 * 8.64e7 // 8.64e7就是一天的时间戳 24*60*60*1000 180天前不可选
      }
    },
    // 绘制图表
    async getItem () {
      if (this.form.startTime == this.form.endTime) {
        this.$message({
          type: 'error',
          message: '开始时间与结束时间不能为同一天!'
        })
        return false
      }
      try {
        const res = await trendChartData({ ...this.form })
        if (res.code == 1) {
          this.dialogTitle = res.result.disPlayName + '趋势折线图'
          const arrX = []
          const arrValue = []
          res.result.items.forEach(item => {
            arrX.push(item.dataKey)
            arrValue.push(item.dataValue)
          })
          const setDataOptin = {
            title: {
              text: res.result.disPlayName
            },
            xAxis: [
              {
                data: arrX
              }
            ],
            legend: {
              data: [res.result.unitName == 'playDoneProportion' || res.result.unitName == 'playValidCount' ? res.result.disPlayName : (res.result.unitName == 'playTimeProportion' ? res.result.disPlayName + '/分钟' : res.result.disPlayName + '/次')]
            },
            series: [
              {
                name: res.result.unitName == 'playDoneProportion' || res.result.unitName == 'playValidCount' ? res.result.disPlayName : (res.result.unitName == 'playTimeProportion' ? res.result.disPlayName + '/分钟' : res.result.disPlayName + '/次'),
                data: arrValue
              }
            ]
          }
          this.itemBox.setOption(setDataOptin)
        }
      } catch (e) {
        // this.$message.error(JSON.stringify(e))
      }
    },
    weeksData () { // 周数据分析
      const Option = {
        title: {
          text: '',
          left: '2%',
          textStyle: { color: '#33343B', fontStyle: 'normal', fontWeight: 500, fontSize: 18 }
        },
        tooltip: { // 提示框 component
          trigger: 'axis',
          backgroundColor: '#fff',
          textStyle: { color: '#66697', fontSize: 7, lineHeight: 25 },
          axisPointer: { type: 'cross', label: { backgroundColor: '#6a7985' } }
        },
        grid: { // 直角坐标系的底板 component
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
          tooltip: { borderColor: '#f0f' }
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            axisLabel: { color: '#666978' },
            axisLine: { lineStyle: { color: 'rgba(0, 0, 0, 0.45)', width: 1, type: 'solid' } },
            data: []
          }
        ],
        yAxis: {
          type: 'value',
          splitLine: { lineStyle: { type: 'dashed' } }, // 网格线
          axisLine: { lineStyle: { color: 'rgba(0, 0, 0, 0.45)', width: 1, type: 'solid' } },
          axisLabel: { color: '#666978' },
          nameTextStyle: { color: 'rgba(0, 0, 0, 0.45)' }
        },
        legend: {
          right: '2%',
          top: '4%',
          icon: 'rect',
          itemWidth: 12,
          itemHeight: 4,
          textStyle: { color: '#2C3542' },
          data: []
        },
        series: [
          {
            name: '',
            type: 'line',
            data: [],
            symbol: 'none',
            itemStyle: { color: '#3FD4FF' }
          }
        ]
      }
      const dataChart = this.$echarts.init(document.getElementById('weekAna'))
      // 绘制图表
      this.itemBox = dataChart
      this.itemBox.setOption(Option)
      this.getItem()
    }
  },
  watch: {
    dialogData (n, o) {
      this.form.statisticsFields = n.statisticsFields
      this.form.programId = n.objData.programId
      this.form.programsetId = n.objData.programsetId
      this.form.isCharge = n.objData.isCharge
      this.form.limit = n.limit
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~@/assets/css/dataAnalysis.less';
</style>
